import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const SEND_REQUEST = 'SEND_REQUEST';
const UPDATE_DATA = 'UPDATE_DATA';
const REQUEST_FINISHED = 'REQUEST_FINISHED';

const reducerDotPath = `userFlowFundsModule.states.authAccountBalance`;
const createActionName = name => `app/${reducerDotPath}/${name}`;

const createReducer = () => {
  function stateDefault() {
    return {
      ...createRequestState(),
      data: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(SEND_REQUEST):
        return setRequestStateInProgress(state);
      case createActionName(UPDATE_DATA):
        return state.merge({ data: action.payload || {} });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTION REGISTER
export const initState = () => ({
  type: createActionName(INIT_STATE)
});
export const requestFinished = (codeResponse, hasSuccess) => ({
  type: createActionName(REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequest = () => ({
  type: createActionName(SEND_REQUEST)
});
export const updateData = payload => ({
  type: createActionName(UPDATE_DATA),
  payload
});

// SELECTORS
export const getState = state => _.get(state, reducerDotPath);
export const selectRequestState = state =>
  _.get(getState(state), 'requestState');

export const selectBalanceMainAccount = state =>
  getState(state).data.balanceMainAccount;
export const selectBalanceAdsAccount = state =>
  getState(state).data.balanceAdsAccount;
export const selectTotalBalance = state => getState(state).data.totalBalance;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/common/reducers/state/authAccountBalance.js